/**  @jsx jsx */
import { Box } from '@bottlebooks/gatsby-theme-base';
import { jsx, ThemeProvider } from 'theme-ui';
import BaseLayout from './BaseLayout';
import Footer from './Footer';
import FooterLogo from './FooterLogo';
import Header from './Header';
import Logo from './Logo';
import MainMenu from './MainMenu';
import useEventTheme from './useEventTheme';
import { useScroll } from './useScroll';

export default function Layout({
  children,
  paths = {},
  homePath = paths?.home,
  className,
}) {
  const theme = useEventTheme();
  const { showHeader, isScrolledDown } = useScroll();
  return (
    <ThemeProvider theme={theme}>
      <BaseLayout className={className}>
        <Header
          homePath={homePath}
          paths={paths}
          isScrolledDown={isScrolledDown}
          showHeader={showHeader}
        >
          <Logo to={homePath} isScrolledDown={isScrolledDown} />
          <MainMenu paths={paths} isScrolledDown={isScrolledDown} />
        </Header>

        <Box as="main">{children}</Box>

        <Footer sx={{ marginTop: 'auto' }}>
          <FooterLogo to={homePath} />
        </Footer>
      </BaseLayout>
    </ThemeProvider>
  );
}
